// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___Ql3SO","disabled":"styles__disabled___1BE1V"};